import * as React from 'react';
import '@ant-design/compatible/assets/index.css';
import { Layout } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { PageLoadingPlaceholder } from '../page_loading_placeholder/PageLoadingPlaceholder';
import { getEntityById, nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { EmptyState } from '../empty_state/EmptyState';
import { fetchAllWorkOrderNotesForBuyer } from '../../thunks/messages_thunks';
import MessageBubble from '../MessageBubble';
import MessageLog from '../MessageLog';

const { Content } = Layout;

require('./PurchaseOrderNotesPage.less');

class PurchaseOrderNotesPage extends React.Component<any, any> {
	render() {
		const { purchaseOrder, currentUser, fetching } = this.props;
		const notes = nullSafeGetOrElse(`notes`, purchaseOrder, []);
		const actualNotes = notes.filter(
			(n) =>
				(n.text && n.text.length > 0) ||
				(n.photo && n.photo.length > 0) ||
				(n.video && n.video.length > 0) ||
				n.changedBy
		);

		return fetching ? (
			<PageLoadingPlaceholder />
		) : (
			<Content className="PurchaseOrderNotesPage">
				<div
					id="chatBox"
					style={{
						flexGrow: 1,
						overflowY: 'auto',
					}}
					className="no-scrollbar"
				>
					{actualNotes.length > 0 ? (
						<div className="chatList">
							{actualNotes.map((n, idx) => {
								return n.type === 'log' ? (
									<MessageLog log={n} />
								) : (
									<MessageBubble
										currentUser={currentUser}
										n={n}
										idx={idx}
										subscribers={[]}
										userType="supplier"
										key={idx}
									/>
								);
							})}
						</div>
					) : (
						<EmptyState
							graphic={
								<img
									style={{ marginBottom: 8 }}
									src="https://s3.amazonaws.com/mock-data-assets/categories/images/letter owl.svg"
									alt="No notes have been added yet"
								/>
							}
							headline={'No notes have been added yet'}
						/>
					)}
				</div>
			</Content>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	purchaseOrder: getEntityById(ownProps.match.params.id, state.purchase_orders),
	currentUser: state.session.currentUser,
	fetching: state.purchase_orders.fetching,
});

const mapDispatchToProps = (dispatch) => ({
	fetchMessages: (workOrderId) => dispatch(fetchAllWorkOrderNotesForBuyer(workOrderId)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PurchaseOrderNotesPage));
